import { ModelParameters } from "@/components/ModelParameters";
import ThreadsOverlayManager from "@/components/ThreadsOverlayManager";
import { PromptBlueprint } from "@/types";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { usePlayground } from "../../playground-store";
import DetectedInputVariables from "./DetectedInputVariables";

const MessagesFooter = observer(() => {
  const playground = usePlayground();
  const { promptId, versionId } = useParams();

  return (
    <div className=" mx-auto flex w-full flex-col justify-between gap-x-2 gap-y-2 overflow-y-auto border-t pb-1 pt-2 sm:flex-row">
      {playground.detectedInputVariables.length > 0 ? (
        <div className="flex min-w-[150px] flex-1">
          <DetectedInputVariables />
        </div>
      ) : (
        <div />
      )}
      <div className="flex shrink-0 items-center gap-2">
        <ModelParameters
          className="w-full items-center justify-between"
          isPromptChat={playground.isChat}
          promptData={playground.blueprint}
          readonly={playground.readonly}
          onUpdate={(promptData) =>
            playground.applyPromptBlueprintToState(
              promptData as Partial<PromptBlueprint>,
            )
          }
        />
        {promptId && versionId && playground.readonly && (
          <ThreadsOverlayManager
            promptRegistryId={Number(promptId)}
            promptVersionNumber={Number(versionId)}
          />
        )}
      </div>
    </div>
  );
});

export default MessagesFooter;
